import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ActionLogsDataType, HeadActionLogsCSVCell } from '../../types/actionLogsTypes';
import { convertTableToCSV } from '../../utils/csvExportUtils';
import { format, parseISO } from 'date-fns';
import buttonStyles from './buttonStyles';

interface ActionLogsExportButtonProps {
  headCells: readonly HeadActionLogsCSVCell[];
  // Rows to export — the filtered/searched view, not the full dataset.
  rows: ActionLogsDataType[];
}

const ActionLogsExportButton: React.FC<ActionLogsExportButtonProps> = ({ headCells, rows }) => {
  const handleDownloadCSV = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const columnNames = headCells.map((cell) => cell.id);
    const headerLabels = headCells.reduce(
      (acc, col) => ({
        ...acc,
        [col.id]: col.label,
      }),
      {} as Record<string, string>
    );

    const rowsToExport = rows.map((row) => {
      return {
        ...row,
        success: row.success ? 'Success' : 'Failed',
        created_at: format(parseISO(`${row.created_at}Z`), 'yyyy-MM-dd HH:mm'),
        details: JSON.stringify(row.details),
      };
    });
    const csvContent = convertTableToCSV(rowsToExport, headerLabels, {}, undefined, columnNames);

    const csvFile = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(csvFile);
    const link = document.createElement('a');
    const timestamp = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');

    link.href = url;
    link.setAttribute('download', `ActionLogs_${timestamp}.csv`);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <Box sx={buttonStyles.exportButtonBox}>
      <Tooltip describeChild title={'Export to CSV'}>
        <Button
          sx={buttonStyles.exportButton}
          variant="outlined"
          color="primary"
          onClick={handleDownloadCSV}
          startIcon={<FileDownloadIcon />}
        >
          CSV
        </Button>
      </Tooltip>
    </Box>
  );
};

export default ActionLogsExportButton;
